var colors = {
    blueHeader: '#131927',
    blueSubheader: '#202B43',
    blueLineEdit: '#1A2235',
    blueBackground: '#29334c',
    blueAlternate: '#252d44',
    blueGradient: '#1D263B',
    blueGrey: '#4e5565',
    tableBGBlue: '#1b2234',
    tableBorderGrey: '#4e5159',
    gradientDisabled: '#25304A',
    yellow: '#EEE756',
    orange: '#AA7221',
    white: '#FFFDE5',
    black: '#000000',
    grey: '#80807F',
    greenSelected: '#399E6B',
    blueSelected: '#1A2134',
    red: '#FF0000',
    green_: '#00FF00',
    standbyGreen: '#108229',
    lightBlue: '#55AAFF',
    lightOrange: '#FF8000',
    lightBOT: '#99A9B3',
    lightBrown: '#A28131',
    ORF_background_top: '#29385A',
    ORF_background_bottom: '#142040',
    ORF_highlighted_top: '#3B4E77',
    ORF_highlighted_bottom: '#293A5F',
    ORF_pressed_top: '#151C2B',
    ORF_pressed_bottom: '#272A39',
    border: '#191c2f',
    darkBorder: '#06101f',
    ORF_disabled_color: '#646464',
    IFF_darkblue: '#FFFFFF',
    IFF_yellow: '#000000',
    hermesys_background: 'rgba(32,41,68,1)',
    gray: '#778899',
};
var hermesysTheme = {
    label: {
        fontSize: '16px',
        fontWeight: '400',
        header: {
            subheaderbgColor: colors.blueSubheader,
            headerbgColor: colors.blueHeader,
        },
    },
    groupBox: {
        border: 'none',
        fieldset: {
            border: '2px groove threedface',
            borderRadius: '3px',
        },
        legend: {
            textalign: 'center',
        },
    },
    window: {
        border: "0px",
        title: {
            background: 'white',
            color: colors.black,
        },
        content: {
            background: colors.hermesys_background,
        },
        fontSize: '16px',
        fontFamily: 'Lucida Sans Typewriter',
    },
    comboBox: {
        border: '1px solid',
        backgroundColor: colors.hermesys_background,
        borderColor: {
            top: 'white',
            left: 'white',
            right: 'white',
            bottom: 'white',
        },
        height: '30px',
        borderRadius: '3px',
    },
    radio: {
        label: {
            color: colors.white,
        },
    },
    textInput: {
        backgroundColor: colors.hermesys_background,
        border: '1px solid',
        borderColor: {
            top: 'white',
            left: 'white',
            right: 'white',
            bottom: 'white',
        },
        borderRadius: '3px',
    },
    dataGrid: {
        position: 'relative',
        table: {
            color: 'white',
            border: '1px solid',
            borderColor: colors.white,
            backgroundColor: colors.hermesys_background,
            thead: {
                tr: {
                    th: {
                        border: "1px solid " + colors.white,
                        borderLeft: colors.white,
                        borderTop: colors.black,
                    },
                },
            },
            tbody: {
                tr: {
                    td: {
                        border: '0px',
                    },
                },
            },
        },
    },
    listWidget: {
        backgroundColor: colors.hermesys_background,
        borderColor: {
            left: colors.blueGrey,
            top: colors.blueGrey,
            right: colors.blueGrey,
            bottom: colors.blueGrey,
        },
    },
    gridLayout: {
        item: {
            labelBorder: '1px solid',
            labelBorderColor: colors.blueGrey,
            width: '100%',
        },
    },
    hBoxLayout: {
        height: 'auto',
        width: '100%',
        justifyContent: 'space-between',
        textAlign: 'left',
        alignItems: 'flex-start',
    },
    vBoxLayout: {
        justifyContent: 'flex-start',
        textAlign: 'left',
    },
    button: {
        border: '1px solid',
        borderRadius: '3px',
        width: 'auto',
        fontFamily: 'Lucida Sans Typewriter',
        borderColor: {
            left: colors.white,
            top: colors.white,
            right: colors.white,
            bottom: colors.white,
        },
        disabled: {
            color: colors.grey,
        },
        focus: {
            outline: 'none',
        },
        margin: '10px',
        toggleOnColor: '#c9c1c1a6',
        toggleOffColor: 'inherit',
        hover: {
            backgroundColor: 'none',
        },
    },
    checkbox: {
        content: '',
        position: 'absolute',
        input: {
            background: colors.hermesys_background,
            border: '1px solid white',
            checked: {
                background: colors.hermesys_background,
                content: 'x',
                fontSize: '18px',
                color: 'white',
                opacity: 0,
            },
        },
        label: {
            color: 'white',
        },
        before: "{\n      content: '';\n      position: absolute;\n      width: 15px;\n      height: 15px;\n      border: 1px solid #fff;\n      background: rgb(43, 56, 86);\n      border-radius: 3px;\n    }",
        after: "{\n      content: 'x';\n      position: absolute;\n      padding-left: 4px;\n      font-size: 12px;\n      color: #fff;\n    }",
    },
    calendarContainer: {
        backgroundColor: colors.hermesys_background,
        color: 'white',
        border: '1px solid',
        borderColor: {
            left: colors.white,
            top: colors.white,
            right: colors.white,
            bottom: colors.white,
        },
    },
    tabNavigator: {
        background: 'inherit',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'baseline',
        flexDirection: 'column',
        nav: {
            height: '44px',
            color: colors.white,
            width: '50px',
            display: 'flex',
            justifyContent: 'space-around',
            item: {
                backgroundColor: 'inherit',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                flexGrow: '1',
                textAlign: 'center',
                border: 'inset 1px',
                active: {
                    backgroundColor: colors.gray,
                },
                content: {
                    position: 'relative',
                    flexGrow: '1',
                    width: '100%',
                    border: 'inset 1px',
                },
            },
        },
    },
};
export default hermesysTheme;
//# sourceMappingURL=hermesys-theme.js.map